



















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import axios from 'axios';
import {namespace} from 'vuex-class';
import {SearchState} from '@/store/search/types';

import SearchField from '@/components/SearchField.vue';

const searchState = namespace('search');

@Component({
    components: {
        SearchField,
    },
})
export default class Graph extends Vue {
    @searchState.Action('fillNamespacesList') private fillNamespacesList!: () => void;
    @searchState.State((state) => state) private searchState!: SearchState;
    @searchState.Action('setResultsAction') private setSearchResultsAction!: (p: {}) => void;

    private isActive = false;

    private namespaces: any = [];


    @Prop()
    private parentFunction: any;

    private async mounted() {
        const url = new URL(Vue.prototype.appConfig.adminusUrl + 'namespaces');
        this.namespaces = await axios(url.href);
    }


    private selectedNamespace(ns: any) {
        this.parentFunction(ns);
    }

    get filteredNamesList() {
        if (this.namespaces.length > 0 || this.searchState.query !== '') {
            const filteredNames = [];
            for (const obj of this.namespaces.data) {
                if (obj.name.includes(this.searchState.query)) {
                    filteredNames.push(obj);
                }
            }
            return filteredNames;
        } else {
            return this.namespaces.data;
        }
    }

}


